export default "__VITE_ASSET__C3Jb7H8W__"